import { IdTsiNavigation } from "../../interfaces/serviceModels/IRequestJSON";
import { setTSICONTENTOBJECT } from "../constants/tsiContentObject.types";

export const setTsiContentObject = (tsiObject: IdTsiNavigation) => {
  return {
    type: setTSICONTENTOBJECT,
    payload: tsiObject,
  };
};
